import types from '../mutation-types';
import WorkflowsAPI from '../../api/workflows';

export const state = {
  records: [],
  capabilities: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isPublishing: false,
  },
};

export const getters = {
  getWorkflows(_state) {
    return [..._state.records].sort((a, b) => a.id - b.id);
  },
  getWorkflow: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
  getCapabilities(_state) {
    return _state.capabilities;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_WORKFLOW_UI_FLAG, { isFetching: true });
    try {
      const response = await WorkflowsAPI.get();
      commit(types.SET_WORKFLOWS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_WORKFLOW_UI_FLAG, { isFetching: false });
    }
  },
  show: async ({ commit }, id) => {
    commit(types.SET_WORKFLOW_UI_FLAG, { isFetching: true });
    try {
      const response = await WorkflowsAPI.show(id);
      commit(types.EDIT_WORKFLOW, response.data.payload);
      return response.data.payload;
    } finally {
      commit(types.SET_WORKFLOW_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, workflowObj) => {
    commit(types.SET_WORKFLOW_UI_FLAG, { isCreating: true });
    try {
      const response = await WorkflowsAPI.create(workflowObj);
      commit(types.ADD_WORKFLOW, response.data.payload);
      return response.data.payload;
    } finally {
      commit(types.SET_WORKFLOW_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_WORKFLOW_UI_FLAG, { isUpdating: true });
    try {
      const response = await WorkflowsAPI.update(id, updateObj);
      commit(types.EDIT_WORKFLOW, response.data.payload);
      return response.data.payload;
    } finally {
      commit(types.SET_WORKFLOW_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_WORKFLOW_UI_FLAG, { isDeleting: true });
    try {
      await WorkflowsAPI.delete(id);
      commit(types.DELETE_WORKFLOW, id);
    } finally {
      commit(types.SET_WORKFLOW_UI_FLAG, { isDeleting: false });
    }
  },
  publish: async ({ commit }, id) => {
    commit(types.SET_WORKFLOW_UI_FLAG, { isPublishing: true });
    try {
      const response = await WorkflowsAPI.publish(id);
      commit(types.EDIT_WORKFLOW, response.data.payload);
      return response.data.payload;
    } finally {
      commit(types.SET_WORKFLOW_UI_FLAG, { isPublishing: false });
    }
  },
  fetchCapabilities: async ({ commit }) => {
    try {
      const response = await WorkflowsAPI.capabilities();
      commit(types.SET_WORKFLOW_CAPABILITIES, response.data.payload);
    } catch (error) {
      // Ignore error
    }
  },
};

export const mutations = {
  [types.SET_WORKFLOW_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_WORKFLOWS](_state, records) {
    _state.records = records;
  },
  [types.ADD_WORKFLOW](_state, record) {
    _state.records.push(record);
  },
  [types.EDIT_WORKFLOW](_state, record) {
    const index = _state.records.findIndex(item => item.id === record.id);
    if (index > -1) {
      _state.records.splice(index, 1, record);
    } else {
      _state.records.push(record);
    }
  },
  [types.DELETE_WORKFLOW](_state, id) {
    _state.records = _state.records.filter(record => record.id !== id);
  },
  [types.SET_WORKFLOW_CAPABILITIES](_state, capabilities) {
    _state.capabilities = capabilities;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
